import React, { Component } from 'react';
import { clientSharingService } from '../../_services/clientSharing.service';
// Errors only: the switch only moves once its save lands.
import toast from '../shared/Toast';
import './Clients.css';

/**
 * Salon setting: "Add clients to a stylist's list when you book them" (on
 * unless switched off). When salon staff book one of the salon's
 * clients with a self-employed stylist — or the client books them on the
 * salon's own page — the client also goes into that stylist's clients. The
 * booking panel lets staff choose per booking. Shown only to people who may
 * change salon settings (the server says: canChange).
 */
class ShareBookedClientsSetting extends Component {
  state = { loaded: false, on: true, canChange: false, saving: false };

  componentDidMount() {
    clientSharingService.getSetting()
      .then((r) => {
        this.setState({ loaded: true, on: r.shareSEBookedClients !== false, canChange: !!r.canChange });
        this.tell(r.shareSEBookedClients !== false, r.businessName);
      })
      .catch(() => this.setState({ loaded: true, canChange: false }));
  }

  // The Sharing page words each stylist's line from this setting.
  tell(on, businessName) {
    if (businessName !== undefined) this.biz = businessName || '';
    if (this.props.onChange) this.props.onChange({ on, businessName: this.biz || '' });
  }

  toggle = () => {
    if (this.state.saving) return;
    const next = !this.state.on;
    this.setState({ saving: true });
    clientSharingService.setSetting(next)
      .then((r) => {
        this.setState({ saving: false, on: r.shareSEBookedClients !== false });
        this.tell(r.shareSEBookedClients !== false);
      })
      .catch(() => {
        this.setState({ saving: false });
        toast.error('That didn’t save. Try again in a moment.');
      });
  };

  render() {
    const { loaded, on, canChange, saving } = this.state;
    if (!loaded || !canChange) return null;
    return (
      <div className="ds-bulk-card">
        <div className="ds-bulk-text">
          <span className="ds-bulk-title">Add clients to a stylist’s list when you book them</span>
          <span className="ds-bulk-desc">
            {on
              ? 'When you book one of your clients with a self-employed stylist, the client goes on that stylist’s list too. You can untick it on any booking.'
              : 'Clients you book with a self-employed stylist stay on your list only. You can still tick it on a booking.'}
          </span>
        </div>
        <button
          type="button"
          className={'ds-toggle' + (on ? ' ds-toggle--on' : '') + (saving ? ' ds-toggle--disabled' : '')}
          onClick={this.toggle}
          disabled={saving}
          aria-pressed={on}
          aria-label="Add clients to a stylist’s list when you book them"
        >
          <span className="ds-toggle-knob" />
        </button>
      </div>
    );
  }
}

export default ShareBookedClientsSetting;
